import {
  FETCH_INSIGHTS_AI_REQUEST,
  FETCH_INSIGHTS_AI_SUCCESS,
  FETCH_INSIGHTS_AI_CANCEL,
  FETCH_INSIGHTS_AI_ERROR,
  SHOW_INSIGHTS_AI_SIDEBAR,
} from "./constants";

// Insights Ai
export const showInsightsAiSidebar = (show) => ({
  type: SHOW_INSIGHTS_AI_SIDEBAR,
  show,
});

export const InsightsAiRequested = (insightType) => ({
  type: FETCH_INSIGHTS_AI_REQUEST,
  payload: { insightType },
});

export const insightsAiSuccess = (insightType, data) => ({
  type: FETCH_INSIGHTS_AI_SUCCESS,
  payload: { insightType, data },
});

export const insightsAiCancel = (insightType) => ({
  type: FETCH_INSIGHTS_AI_CANCEL,
  payload: { insightType },
});

export const insightsAiError = (insightType) => ({
  type: FETCH_INSIGHTS_AI_ERROR,
  payload: { insightType },
});
